// extracted by mini-css-extract-plugin
export default {"editQueryContainer":"BEditQueryDialogWithLabel-module_editQueryContainer_bb3d7b02","editQuery":"BEditQueryDialogWithLabel-module_editQuery_a7695ac7"};